import { render } from "./CartCoupon.vue?vue&type=template&id=526e6d2c"
import script from "./CartCoupon.vue?vue&type=script&lang=js"
export * from "./CartCoupon.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__